import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'

import AssignedItemsButton from 'components/AssignedItemsButton'

import { ReactComponent as PencilIcon } from 'assets/icons/IconPencil.svg'
import { ReactComponent as IconSettings } from 'assets/icons/IconSettings.svg'
import {
  getAssignedItemsToMenu,
  getServiceTypesWithItems,
} from 'store/RevenueCenters/selector'

const ServiceTypeItem = ({
  uuid,
  serviceType,
  displayName,
  handleSaveValues,
}) => {
  const history = useHistory()

  const assignedItemsToMenu = useSelector((state) =>
    getAssignedItemsToMenu(state, uuid)
  )
  const serviceTypesWithItems = useSelector(getServiceTypesWithItems)

  // if redux store value serviceTypesWithItems includes object with current menu, then return length of his uuids,
  // if not then will be reuturned length of assignedItemsToMenu
  const assignedItemsLength =
    serviceTypesWithItems[uuid] !== undefined
      ? serviceTypesWithItems[uuid]?.length
      : assignedItemsToMenu?.length

  const handleClickAssignedItems = () => {
    handleSaveValues()
    history.push(`${history.location.pathname}/items/${uuid}`)
  }

  const onClickSettingsServiceType = (uuid) => {
    handleSaveValues()
    history.push(`${history.location.pathname}/menu-settings/${uuid}`)
  }

  const onClickEditServiceType = (uuid) => {
    handleSaveValues()
    history.push(
      `${history.location.pathname}/add-service-type/${uuid}`
    )
  }

  return (
    <div className="service-type" key={uuid}>
      <div className="service-type__describe">
        <p className="service-type__name">
          {serviceType}: {displayName}
        </p>
        <span
          className="service-type__settings-icon"
          onClick={() => onClickSettingsServiceType(uuid)}
        >
          <IconSettings />
        </span>
        <span
          className="service-type__pencil-icon"
          onClick={() => onClickEditServiceType(uuid)}
        >
          <PencilIcon />
        </span>
      </div>
      <div className="content-wrapper">
        <AssignedItemsButton
          label="Select Items"
          handleClick={handleClickAssignedItems}
          assignedItems={assignedItemsLength}
        />
      </div>
    </div>
  )
}

export default ServiceTypeItem
